import { ref } from 'vue'
import type { OutcomeCreationSource } from '../types'

// The shell owns the shared chooser used by navigation entry points.
const visible = ref(false)
const source = ref<OutcomeCreationSource>('sidebar')

export const useOutcomeChooser = () => {
  const open = (fromSource: OutcomeCreationSource) => {
    source.value = fromSource
    visible.value = true
  }

  const close = () => {
    visible.value = false
  }

  return { visible, source, open, close }
}
